import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { TabOptions, TabSelectedEvent, TabSize, TabType } from '@design-system/components/molecules/tab/entities/tab.types';

@Component({
  selector: 'app-billing-section-switch',
  templateUrl: './billing-section-switch.component.html',
  styleUrls: ['./billing-section-switch.component.sass'],
  standalone: false
})
export class BillingSectionSwitchComponent {
  @Input() disabledCompanyBillingForm: boolean;
  @Input() activeNaturalPerson: boolean;
  @Input() disbleSwitch: boolean;

  @Output() clickSwitch: EventEmitter<boolean> = new EventEmitter();

  public readonly tabType = TabType.Pill;
  public readonly tabSize = TabSize.SM;

  constructor(
    private readonly transloco: TranslocoService,
  ) { }

  get options(): TabOptions {
    return [
      {
        Title: this.transloco.translate('BOOKING_MODULE.BILLING.NATURAL_PERSON'),
        Icon: null,
      },
      !this.disabledCompanyBillingForm ? {
        Title: this.transloco.translate('BOOKING_MODULE.BILLING.COMPANY'),
        Icon: null,
      } : null
    ];
  }

  get defaultOption(): number {
    return this.activeNaturalPerson ? 0 : 1;
  }

  public onClickSwitch(event: TabSelectedEvent) {
    this.clickSwitch.emit(!event.option);
  }
}
